import type { PublicProject } from './types';
export function projectStage(project?: PublicProject | null) {
  if (!project) return 0;
  if (project.gardenUnlocked || project.completed) return 4;
  return Math.min(3, Math.ceil((project.progress / Math.max(1, project.target)) * 3));
}
